import React from "react";

export default function Analytics() {
  const imageIndices = Array.from({ length: 13 }, (_, i) => i + 1);

  return (
    <section className="relative w-full overflow-hidden">
      <div className="mx-auto max-w-4xl px-6 py-14">
        <div className="text-center mb-12 px-4 md:px-20 lg:px-32">
          <h1 
            className="
              mb-4 w-full
              font-uber text-[28px] font-bold leading-[36px] text-current
              sm:text-[32px] sm:leading-[40px]
              xl-custom:text-[36px] xl-custom:leading-[44px]
            "
          >
            What we do with Playables?
          </h1>
          
          <p 
            className="
              max-w-4xl mx-auto
              font-uber text-base font-normal leading-normal
            "
          >
            Seamless digital experiences translate into measurable success - Boosting engagement and conversion
          </p>
        </div>

        <div className="grid grid-cols-1 xl-custom:grid-cols-2 gap-4 sm:gap-6 md:gap-8">
          {imageIndices.map((index) => (
            <div 
              key={index} 
              className="rounded-xl overflow-hidden"
            >
              <img
                src={`/uploads/Analytics/${index}.webp`}
                alt={`Analytics Detail ${index}`}
                className="w-full h-auto object-cover rounded-xl"
                onError={(e) => {
                  e.target.onerror = null;
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}